export class FieldCrops {
    cropId: number;
    campaignId: number;
    fieldId: number;
    hectares: number;
    campaignName: string;
    cropName: string;
}
